import type { RefObject } from 'react'

export const DEFAULT_SNACKBAR_DISTANCE = '1.5rem'
export const MARGIN_PROPERTY = 'right'

export const computeInitialTopDistance = (
	headerRef: RefObject<HTMLHeadElement>,
	headerHeight: number
) => {
	return headerRef.current
		? `calc(${headerHeight}px + ${DEFAULT_SNACKBAR_DISTANCE})`
		: DEFAULT_SNACKBAR_DISTANCE
}
